import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('cooperate', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 C11.1046,10 12,9.10457 12,8 C12,6.89543 11.1046,6 10,6 C8.89543,6 8,6.89543 8,8 C8,9.10457 8.89543,10 10,10 Z M10,9 C10.5523,9 11,8.55228 11,8 C11,7.44772 10.5523,7 10,7 C9.44772,7 9,7.44772 9,8 C9,8.55228 9.44772,9 10,9 Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,10 C18.1046,10 19,9.10457 19,8 C19,6.89543 18.1046,6 17,6 C15.8954,6 15,6.89543 15,8 C15,9.10457 15.8954,10 17,10 Z M17,9 C17.5523,9 18,8.55228 18,8 C18,7.44772 17.5523,7 17,7 C16.4477,7 16,7.44772 16,8 C16,8.55228 16.4477,9 17,9 Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10 C8.89543,10 8,10.8954 8,12 L8,17 C8,17.5523 8.44772,18 9,18 L11,18 C11.5523,18 12,17.5523 12,17 L12,12 C12,10.8954 11.1046,10 10,10 Z M10,11 C9.44772,11 9,11.4477 9,12 L9,17 L11,17 L11,12 C11,11.4477 10.5523,11 10,11 Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,10 C15.8954,10 15,10.8954 15,12 L15,17 C15,17.5523 15.4477,18 16,18 L18,18 C18.5523,18 19,17.5523 19,17 L19,12 C19,10.8954 18.1046,10 17,10 Z M17,11 C16.4477,11 16,11.4477 16,12 L16,17 L18,17 L18,12 C18,11.4477 17.5523,11 17,11 Z",
    fill: props.colors[0]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,3 C1,2.44772 1.44772,2 2,2 L17.9999,2 C18.5522,2 18.9999,2.44772 18.9999,3 L18.9999,5 L18,5 L18,3.5 C18,3.22386 17.7761,3 17.5,3 L2.49999,3 C2.22385,3 1.99999,3.22386 1.99999,3.5 L1.99999,13.5 C1.99999,13.7761 2.22385,14 2.49999,14 L3.49998,14 C3.77613,14 3.99998,14.2239 3.99998,14.5 L3.99998,15.97 L5.70676,14.0024 C5.70698,14.0021 5.70711,14.0018 5.70711,14.0014 C5.70711,14.0006 5.70775,14 5.70854,14 L7.02003,14 L7.02003,15 L6.056,15 L3.85202,17.1852 C3.53643,17.4981 2.99998,17.2745 2.99998,16.8301 L2.99998,15 L2,15 C1.44772,15 1,14.5523 1,14 L1,3 Z M13.3597,13.3896 C13.4378,13.4677 13.5644,13.4677 13.6426,13.3896 L15.1505,11.8817 L15.8576,12.5888 L13.8644,14.5783 C13.6641,14.7807 13.3354,14.7796 13.134,14.5783 L11.0547,12.4988 L11.7618,11.7917 L13.3597,13.3896 Z",
    fill: props.colors[0]
  }))));
});